'use strict';
import * as $j_app$002edata$002e$002dDocument$002dReference$002dWith$002dVersion$0024$0024anon$00244 from "./app.data.-Document-Reference-With-Version$$anon$4.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentReferenceWithVersion(id, number, version) {
  this.XY = null;
  this.LG = null;
  this.XZ = 0;
  this.XY = id;
  this.LG = number;
  this.XZ = version;
}
export { $c_Lapp_data_DocumentReferenceWithVersion as $c_Lapp_data_DocumentReferenceWithVersion };
$p = $c_Lapp_data_DocumentReferenceWithVersion.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentReferenceWithVersion;
/** @constructor */
function $h_Lapp_data_DocumentReferenceWithVersion() {
}
export { $h_Lapp_data_DocumentReferenceWithVersion as $h_Lapp_data_DocumentReferenceWithVersion };
$h_Lapp_data_DocumentReferenceWithVersion.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_DocumentReferenceWithVersion)) {
    var x = this.XY;
    var x$2 = x$0.XY;
    if ((((x === null) ? (x$2 === null) : x.f(x$2)) && (this.LG === x$0.LG))) {
      return (this.XZ === x$0.XZ);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "DocumentReferenceWithVersion";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.XY;
      break;
    }
    case 1: {
      return this.LG;
      break;
    }
    case 2: {
      return this.XZ;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "number";
      break;
    }
    case 2: {
      return "version";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.c08 = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  return new $j_app$002edata$002e$002dDocument$002dReference$002dWith$002dVersion$0024$0024anon$00244.$c_Lapp_data_DocumentReferenceWithVersion$$anon$4().bwP(this);
});
function $isArrayOf_Lapp_data_DocumentReferenceWithVersion(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jn)));
}
export { $isArrayOf_Lapp_data_DocumentReferenceWithVersion as $isArrayOf_Lapp_data_DocumentReferenceWithVersion };
var $d_Lapp_data_DocumentReferenceWithVersion = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentReferenceWithVersion, "app.data.DocumentReferenceWithVersion", ({
  jn: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_DocumentReferenceWithVersion as $d_Lapp_data_DocumentReferenceWithVersion };
//# sourceMappingURL=app.data.-Document-Reference-With-Version.js.map
